import React from "react"; 
import { Spinner } from "reactstrap"; 
import { Button } from "../../components/Component";

const MyButton = ({isLoading,mode}) => {
  return (
    <div className="form-group" style={{ marginTop: "31px" }}>
      <Button disabled={isLoading} color="primary" size="md">
        {isLoading ? <Spinner size="sm" color="light" /> : mode == "Add" ? "Save" : "Update"}
      </Button>
    </div>
  );
};

export default MyButton;
